<template>
    <div
        class="relative border rounded-2xl py-8 sm:py-12 px-4 sm:px-6 flex items-center lg:space-x-12 overflow-hidden"
        :class="{ 'border-0': wall.id && !wall.border }"
        :style="{
            'background-color': wall.backColor,
            'border-color': wall.borderColor,
            'border-radius': wall.borderRadius + 'px',
        }"
    >
        <div
            class="hidden lg:flex slider-arrow love-big-slider-arrow-left flex-shrink-0 h-11 w-11 rounded-full items-center justify-center border opacity-75 hover:opacity-100"
            role="button"
            tabindex="0"
            :style="{
                color: wall.textColor,
                borderColor: wall.borderColor,
            }"
        >
            <ChevronLeftIcon class="h-5 w-5" />
        </div>
        <div class="flex-grow overflow-hidden">
            <div class="loveSlider">
                <div v-for="testimonial in notHidedTestimonials" :key="testimonial.id">
                    <ReviewBig :wall="wall" :testimonial="testimonial" />
                </div>
            </div>
        </div>
        <div
            class="hidden lg:flex slider-arrow love-big-slider-arrow-right flex-shrink-0 h-11 w-11 rounded-full items-center justify-center border opacity-75 hover:opacity-100"
            role="button"
            tabindex="0"
            :style="{
                color: wall.textColor,
                borderColor: wall.borderColor,
            }"
        >
            <ChevronRightIcon class="h-5 w-5" />
        </div>
    </div>
    <div class="love-big-slider-nav tns-nav lg:hidden">
        <button v-for="testimonial in notHidedTestimonials" :key="testimonial.id"></button>
    </div>
</template>

<script>
import ReviewBig from "./ReviewBig.vue";
import { tns } from "tiny-slider/src/tiny-slider";
import { ChevronLeftIcon, ChevronRightIcon } from "@easy/ui/icons";
export default {
    name: "Bigslider",
    props: {
        wall: Object,
    },
    data() {
        return {
            loveSlider: null,
        };
    },
    computed: {
        notHidedTestimonials() {
            const notHidedTestimonials = this.wall.testimonials.filter(
                (x) => !x.hide && !x._deleted && x.isPublished
            );
            return notHidedTestimonials;
        },
        testimonialsLength() {
            return this.notHidedTestimonials.length;
        },
    },
    watch: {
        testimonialsLength: {
            handler: function () {
                this.refreshSlider();
            },
        },
    },
    components: {
        ReviewBig,
        ChevronRightIcon,
        ChevronLeftIcon,
    },
    mounted() {
        this.startSlider();
    },
    beforeUnmount() {
        this.destroySlider();
    },
    methods: {
        startSlider() {
            "undefined" != typeof tns &&
                document.querySelector(".loveSlider") &&
                !document.querySelector(".loveSlider.tns-slider") &&
                (this.loveSlider = tns({
                    container: ".loveSlider",
                    items: 1,
                    slideBy: "page",
                    gutter: 10,
                    nextButton: document.querySelector(".love-big-slider-arrow-right"),
                    prevButton: document.querySelector(".love-big-slider-arrow-left"),
                    loop: !1,
                    navPosition: "bottom",
                    navContainer: document.querySelector(".love-big-slider-nav"),
                    nav: true,
                }));
        },
        destroySlider() {
            this.loveSlider?.destroy && this.loveSlider.destroy();
        },
        refreshSlider() {
            setTimeout(() => {
                this.loveSlider?.rebuild && this.loveSlider.rebuild();
            }, 300);
        },
    },
};
</script>
